export default __webpack_public_path__ + "static/media/sales2.addbd230.gif";